import Chaplin from 'chaplin';

const Block = Chaplin.Model.extend({});

export default Block;
